import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';
import { TriviaResultComponent } from '../components/Result';
import { TriviaRankingComponent } from '../components/Ranking';
import * as actions from '../actions';
import * as selectors from '../selectors';

class ResultComponent extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ).isRequired,
    answer: PropTypes.shape({
      earnedPoints: PropTypes.number.isRequired,
    }).isRequired,
    userRanking: PropTypes.shape({
      position: PropTypes.number.isRequired,
      of: PropTypes.number.isRequired,
    }).isRequired,
    dismiss: PropTypes.func.isRequired,
  };

  state = {
    showResult: true,
    showRanking: false,
  };

  animationTimeout = 300;

  showRanking = () => {
    this.setState({
      showResult: false,
    });
    setTimeout(() => {
      this.setState({
        showRanking: true,
      });
    }, this.animationTimeout);
  };

  render() {
    const { title, choices, answer, userRanking, dismiss } = this.props;
    const { showRanking, showResult } = this.state;
    return (
      <Fragment>
        <Fade in={showResult} timeout={this.animationTimeout} mountOnEnter unmountOnExit>
          <TriviaResultComponent
            title={title}
            choices={choices}
            answer={answer}
            actionClick={this.showRanking}
          />
        </Fade>
        <Slide
          direction="left"
          in={showRanking}
          timeout={this.animationTimeout}
          mountOnEnter
          unmountOnExit
        >
          <TriviaRankingComponent answer={answer} userRanking={userRanking} actionClick={dismiss} />
        </Slide>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  title: selectors.title(state, ownProps),
  choices: selectors.choices(state, ownProps),
  answer: selectors.answer(state, ownProps),
  userRanking: selectors.userRanking(state, ownProps),
});

const mapDispatchToProps = {
  dismiss: actions.clear,
};

export const TriviaResult = connect(mapStateToProps, mapDispatchToProps)(ResultComponent);
